import React, { useCallback, useEffect, useRef, useState } from "react";
import { Spin, Select, Checkbox, Form, Input, Button, Table, Modal, message, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getGenderCategory } from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getGender } from "../../redux/actions/gender.action";
import { getSku } from "../../redux/actions/sku.action"
import { ReadCookie } from "../../utils/readCookie";
import { getStyle } from "../../redux/actions/style";
import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo-black.svg";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../Distributor/Distributor.css";
import { useHistory } from "react-router-dom";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import numeral from "numeral";
import { generateDynamicPDF } from "../../utils/generateDynamicPDF";
import { getFitCategory } from "../../redux/actions/fitCategory.action";
import { getAmazonProductInformation, getAmazonViewProduct } from "../../redux/actions/amazonProductInformation.action";
import Loader from "react-spinners/BarLoader";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getSize } from "../../redux/actions/size.action";
import { getWashName } from "../../redux/actions/wash.action";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import { getFabric } from "../../redux/actions/fabric.action";
import { Axios } from "axios";
import { Row, Col, Divider, Tag, Image } from "antd";


const AmazonProductInformation = ({ token }) => {
  TabTitle("Amazon-pr")
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    productStatus,
    style,
    gender,
    genderCategory,
    season,
    wash,
    fitCategory,
    genderCategoryChange,
    styleChange,
    Sku,
    seasonYear,
    fabric,
    amazonProductInformation
  } = useSelector((state) => state);
  const history = useHistory();
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([])
  const [excelData, setExcelData] = useState([])
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [allSelected, setAllSelected] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const { Option } = Select;



  const handleAllChange = (e) => {
    if (e.target.checked) {
      setAllSelected(true);
      setSelectedStatuses([]);
    }
  };

  const handleStatusChange = (id, checked) => {
    let updated = [...selectedStatuses];

    if (checked) {
      updated.push(id);
    } else {
      updated = updated.filter(item => item !== id);
    }
    setSelectedStatuses(updated);

    if (updated.length === 0) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  };



  const onFinish = async (e) => {
    setLoading(true)
    setSelectedRows([])
    await form.validateFields().then((values) => {
      const formData = {
        ...values,
        product_status: allSelected ? null : selectedStatuses.join(","),
      }
      dispatch(getAmazonProductInformation(token, formData)).then((res => {
        setLoading(false)
        setData(res?.payload?.data)
        downloadExcelFileData(res?.payload?.data);
      }));
    });
  };


  const handleViewClick = (record) => {
    console.log("record", record.parent_item_code)
    setIsViewModalOpen(true);
    setViewLoading(true);

    dispatch(getAmazonViewProduct(token, record.parent_item_code, record.inseam)).then((res) => {
      setViewLoading(false);
      setTableData(res?.payload?.data || []);
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };


  function downloadExcelFileData(data) {
    if (data?.length > 0) {
      setExcelData(
        data.map((v) => {
          return {
            "Brand": v.brand,
            "Parent Item Code": v.parent_item_code,
            "Inseam": v.inseam,
            "Gender Category": v.gender_category_name,
            "Fit Category": v.fit_category_name,
            "Gender": v.gender_name,
            "Style": v.style_name,
            "Wash Type": v.wash_type_name,
            "Wash": v.wash_name,
            "Fabric": v.fabric_name,
            "Cut": v.cut_name,
            "Season": v.season_name,
            "Price": v.price,
            "Stock Count": v.stock_count,
            "Status": v.status,
          };
        })
      )
    }
  }


  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getProductType(token));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getProductClass(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getSeasonYear(token, menuId));
    dispatch(getFabric(token, menuId));
  }, [dispatch, menuId, token]);



  const handlePrint = () => {
    const css = '@page { margin-top: 15px; margin-bottom: 15px;  size: landscape;  }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };


  const columns = [
    {
      title: "View",
      align: "center",
      render: (_, record) => (
        <Button
          style={{ height: '16px', fontSize: '11px', padding: '0px 10px' }}
          type="link"
          onClick={() => handleViewClick(record)}
        // onClick={() => {
        //   setViewRecord(record);
        //   setIsViewModalOpen(true);
        // }}
        >
          View
        </Button>
      ),
    },
    {
      title: "S#",
      align: "center",
      width: "60px",
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
      sorter: (a, b) => {
        if ((a.brand !== null) & (b.brand !== null)) {
          return a.brand.localeCompare(b.brand);
        }
      },
    },
    {
      title: "Parent Item Code",
      dataIndex: "parent_item_code",
      key: "parent_item_code",
      sorter: (a, b) => {
        if ((a.parent_item_code !== null) & (b.parent_item_code !== null)) {
          return a.parent_item_code.localeCompare(b.parent_item_code);
        }
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      sorter: (a, b) => {
        if ((a.inseam !== null) & (b.inseam !== null)) {
          return a.inseam - b.inseam;
        }
      },
    },
    {
      title: "Gender Category",
      dataIndex: "gender_category_name",
      key: "gender_category_name",
      sorter: (a, b) => {
        if ((a.gender_category_name !== null) & (b.gender_category_name !== null)) {
          return a.gender_category_name.localeCompare(b.gender_category_name);
        }
      },
    },
    {
      title: "Fit Category",
      dataIndex: "fit_category_name",
      key: "fit_category_name",
      sorter: (a, b) => {
        if ((a.fit_category_name !== null) & (b.fit_category_name !== null)) {
          return a.fit_category_name.localeCompare(b.fit_category_name);
        }
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      sorter: (a, b) => {
        if ((a.gender_name !== null) & (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      sorter: (a, b) => {
        if ((a.style_name !== null) & (b.style_name !== null)) {
          return a.style_name.localeCompare(b.style_name);
        }
      },
    },
    {
      title: "Wash Type",
      dataIndex: "wash_type_name",
      key: "wash_type_name",
      sorter: (a, b) => {
        if ((a.wash_type_name !== null) & (b.wash_type_name !== null)) {
          return a.wash_type_name.localeCompare(b.wash_type_name);
        }
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      sorter: (a, b) => {
        if ((a.wash_name !== null) & (b.wash_name !== null)) {
          return a.wash_name.localeCompare(b.wash_name);
        }
      },
    },
    {
      title: "Fabric",
      dataIndex: "fabric_name",
      key: "fabric_name",
      sorter: (a, b) => {
        if ((a.fabric_name !== null) & (b.fabric_name !== null)) {
          return a.fabric_name.localeCompare(b.fabric_name);
        }
      },
    },
    {
      title: "Cut",
      dataIndex: "cut_name",
      key: "cut_name",
      sorter: (a, b) => {
        if ((a.cut_name !== null) & (b.cut_name !== null)) {
          return a.cut_name.localeCompare(b.cut_name);
        }
      },
    },
    {
      title: "Season",
      dataIndex: "season_name",
      key: "season_name",
      sorter: (a, b) => {
        if ((a.season_name !== null) & (b.season_name !== null)) {
          return a.season_name.localeCompare(b.season_name);
        }
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      align: "right",
      render: (text, record) => {
        return <>${numeral(text).format('0,0')}</>
      },
      sorter: (a, b) => {
        if ((a.price !== null) & (b.price !== null)) {
          return a.price - b.price;
        }
      },
    },
    {
      title: "Stock Count",
      dataIndex: "stock_count",
      key: "stock_count",
      align: "right",
      sorter: (a, b) => {
        if ((a.stock_count !== null) & (b.stock_count !== null)) {
          return a.stock_count - b.stock_count;
        }
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => {
        if ((a.status !== null) & (b.status !== null)) {
          return a.status.localeCompare(b.status);
        }
      },
    },
  ];

  const viewColumns = [
    {
      title: "S#",
      align: "center",
      width: "60px",
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Parent Item Code",
      dataIndex: "parent_item_code",
      key: "parent_item_code",
      sorter: (a, b) => {
        if ((a.parent_item_code !== null) & (b.parent_item_code !== null)) {
          return a.parent_item_code.localeCompare(b.parent_item_code);
        }
      },
    },
    {
      title: "Item Code",
      dataIndex: "item_code",
      key: "item_code",
      sorter: (a, b) => {
        if ((a.item_code !== null) & (b.item_code !== null)) {
          return a.item_code.localeCompare(b.item_code);
        }
      },
    },
    {
      title: "UPC Code",
      dataIndex: "upc_code",
      key: "upc_code",
      sorter: (a, b) => {
        if ((a.upc_code !== null) & (b.upc_code !== null)) {
          return a.upc_code.localeCompare(b.upc_code);
        }
      },
    },
    {
      title: "Stock Count",
      dataIndex: "stock_count",
      key: "stock_count",
      align: "right",
      sorter: (a, b) => {
        if ((a.stock_count !== null) & (b.stock_count !== null)) {
          return a.stock_count - b.stock_count;
        }
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      align: "right",
      render: (text, record) => {
        return <>${numeral(text).format('0,0')}</>
      },
      sorter: (a, b) => {
        if ((a.price !== null) & (b.price !== null)) {
          return a.price - b.price;
        }
      },
    },
    {
      title: "Availability",
      dataIndex: "availability",
      key: "availability",
      sorter: (a, b) => {
        if ((a.availability !== null) & (b.availability !== null)) {
          return a.availability.localeCompare(b.availability);
        }
      },
    },
  ]

  function debounce(cb, delay = 1000) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  }


  const handleSkuSearch = () => {
    dispatch(getSku(token, null, null, null));
  }

  const optimizedFn = useCallback(debounce(handleSkuSearch), []);


  const handleButtonClick = () => {
    setIsModalVisible(true);
  };

  // const handleConfirm = () => {
  //   setIsModalVisible(false);
  //   setButtonLoading(true);

  //   const productIds = selectedRows.map(row => row?.upc_codes);
  //   const status = amazonProductInformation?.payload?.data[0]?.status === 'Inactive' ? "activate" : "deactivate";
  //   const storeKey = 'ww';

  //   console.log("productIds", productIds);
  //   console.log("status", status);

  //   // Axios.post(
  //   //   'http://localhost:3000/api/products/activateDeactivate',
  //   //   {
  //   //     status,
  //   //     storeKey,
  //   //     productIds,
  //   //   },
  //   //   {
  //   //     headers: {
  //   //       'Content-Type': 'application/json',
  //   //       'X-API-Key': 'wxhnURvdjcDjG7CwqNEAe4C1X8Gna5Q4LHOPw',
  //   //     },
  //   //   }
  //   // )
  //   Promise.resolve({ data: { message: "Success" } })
  //     .then((response) => {
  //       console.log("API Response:", response.data);
  //       // message.success('Products updated successfully!');
  //       // notification(response?.data?.message, "Products updated successfully!");
  //       notification("success", "Products updated successfully!");
  //       setSelectedRows([]); // Clear selected rows

  //       // Call onFinish only after API success
  //       onFinish();
  //     })
  //     .catch((error) => {
  //       console.error("API call error:", error);
  //       message.error('Something went wrong while updating products!');
  //       // notification(error, 'Something went wrong while updating products!')
  //     })
  //     .finally(() => {
  //       setButtonLoading(false); // Stop loader
  //     });
  // };


  const handleConfirm = () => {
    setIsModalVisible(false);
    setButtonLoading(true);

    const productIds = selectedRows.map(row => row?.upc_codes);
    const status =
      amazonProductInformation?.payload?.data[0]?.status === "Inactive"
        ? "activate"
        : "deactivate";
    const storeKey = "ww";

    console.log("productIds", productIds)

    // Axios.post(
    //   'http://localhost:3000/api/products/activateDeactivate',
    //   {
    //     status,
    //     storeKey,
    //     productIds,
    //   },
    //   {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'X-API-Key': 'wxhnURvdjcDjG7CwqNEAe4C1X8Gna5Q4LHOPw',
    //     },
    //   }
    // )

    Promise.resolve({ data: { message: "Success" } })
      .then((response) => {
        notification.success({
          message: "Success",
          description: "Products updated successfully!",
        });

        setSelectedRows([]);
        onFinish();
      })
      .catch((error) => {
        console.error("API call error:", error);

        notification.error({
          message: "Error",
          description: "Something went wrong while updating products!",
        });
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };


  const handleCancel = () => {
    setIsModalVisible(false);
  };


  return (
    <div className="header_class business_header_oms print-container">
      <div className="row justify-content-between business_class_oms distributor distributor_amazon">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        {/* <div className="col-sm-6 box-space pl-sm-0">
                    <div className="brand-para">
                        <div>DL1961 Premium Denim Inc.</div>
                        <div>121 Varick Street</div>
                        <div>4th Floor</div>
                        <div>New York, NY 10013</div>
                        <div>(P) 646-514-9736</div>
                        <div>(F) 212-991-9989</div>
                        <div>(E) sales@DL1961.com</div>
                    </div>
                </div> */}
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8 printing_class">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class">
                <CSVLink
                  filename={"Oms-Stock-Style-Wise-Summary.csv"}
                  data={excelData}
                  style={{ display: "flex" }}
                  onClick={() => {
                  }}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    style={{ borderWidth: "0px", height: "14px" }}
                  // onClick={handleExcelExport}
                  />
                </CSVLink>
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Amazon Product Information
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
      <div className="business_class_oms mb-2 distributor distributor_amazon">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div>
                <label htmlFor="">Product Status</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox checked={allSelected} onChange={handleAllChange}>
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {productStatus &&
                    productStatus?.payload?.data.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox
                              key={it.product_status_id}
                              checked={selectedStatuses.includes(it.product_status_id)}
                              onChange={(e) =>
                                handleStatusChange(it.product_status_id, e.target.checked)
                              }
                            >
                              {it.product_status_name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div>
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Gender</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="gender_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Season</label>
                    <div className=" w-100 fit-selectbox-width">
                      <Form.Item name="season_id" initialValue={'All'}>
                        <Select
                          defaultValue={form.getFieldValue().season_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {season &&
                            season?.payload?.data?.map(
                              (status, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={status.season_id}
                                  >
                                    {status.season_name}
                                  </Option>
                                );
                              }
                            )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Season Year</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="new_season_year_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          defaultValue={form.getFieldValue().new_season_year_id}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value={"All"}>All</Option>
                          {seasonYear?.payload?.data?.map((res) => <Option key={res.season_year_id} value={res.season_year_id}>{res.season_year}</Option>
                          )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Second*/}
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Category</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="gender_category_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {
                            genderCategoryChange &&
                              genderCategoryChange?.payload?.data.length >= 0 ? (
                              genderCategoryChange &&
                              genderCategoryChange?.payload?.data.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_id}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              })
                            ) : (
                              genderCategory &&
                              genderCategory?.payload?.data.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_id}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              })
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/* </div> */}
                {/* <div className="main_form row form-margin"> */}
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Sku</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="sku" initialValue={"All"}>
                        <Select
                          notFoundContent={Sku.loading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Loader type="Oval" color="#3c4b58" height={20} width={20} />
                          </div> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>No Data</div>}
                          className={"select_Inputs"}
                          showSearch
                          onSearch={(value) => {
                            optimizedFn(value)
                          }}
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {Sku &&
                            Sku?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.sku}>
                                  {it.sku}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Style</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {
                            styleChange && styleChange?.payload?.data.length >= 0 ? (
                              styleChange && styleChange?.payload?.data.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            ) : (
                              style && style?.payload?.data.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Wash</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {wash &&
                            wash?.payload?.data?.map(
                              (status, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={status.wash_id}
                                  >
                                    {status.wash_name}
                                  </Option>
                                );
                              }
                            )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Fit Category</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="fit_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {
                            fitCategory?.payload?.data.map((item) => {
                              return <Option defaultValue="All" key={item.fit_category_id} value={item.fit_category_id}>{item.fit_category_name}</Option>
                            })
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/* </div> */}
                {/* <div className="main_form row form-margin"> */}
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Fabric</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="fabric">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {fabric?.payload?.data.map((item) => {
                            return (
                              <Option
                                defaultValue="All"
                                key={item.fabric_id}
                                value={item.fabric_id}
                              >
                                {item.fabric_name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Status
                    </label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item
                        name="status"
                        initialValue={"Active"}
                      >
                        <Select
                          size="small"
                          className={"select_Inputs"}
                        >
                          <Option value="Active">Active</Option>
                          <Option value="Inactive">InActive</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4">
                  <div className=" d-flex flex-row align-items-baseline">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "3px",
                        float: "right",
                      }}
                    >
                      <Button
                        style={{ width: "fit-content" }}
                        type="primary"
                        htmlType="submit"
                        className="submit-btn-btm m-0"
                      >
                        Generate
                      </Button>
                    </div>
                  </div>
                </div>
                {
                  selectedRows?.length > 0 ? (
                    <div className="col-12 col-md-3 d-flex justify-content-end align-items-center">
                      <div className="mx-2">Selected {selectedRows.length}{" "}{selectedRows.length === 1 ? "product" : "products"} </div>
                      <Button
                        type="primary"
                        onClick={handleButtonClick}
                        disabled={buttonLoading}
                      >
                        {buttonLoading ? (
                          <Spin size="small" className="customer_payment_ledger_btn_loader mr-1" />
                        ) : amazonProductInformation?.payload?.data[0]?.status === 'Inactive' ? (
                          'Activate'
                        ) : (
                          'De-Activate'
                        )}
                      </Button>
                    </div>
                  ) : null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="table_content international_order table_content_amazon" style={{ maxWidth: '1600px' }}>
        <div>
          {amazonProductInformation?.payload?.data !== undefined ?
            (
              data?.length > 0 ? (
                <Table
                  className=" border-line-th  bottom-align-th  table-td-border-right  th-general-style td-general-style border prod-table omsTable"
                  ref={tableRef}
                  size="small"
                  bordered={false}
                  type="company"
                  dataSource={data && data}
                  columns={columns}
                  scroll={{ x: 'max-content' }}
                  loading={amazonProductInformation?.loading}
                  pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 100,
                    pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                  }}
                  rowSelection={{
                    ...rowSelection,
                    hideSelectAll: true,
                  }}
                  rowKey="parent_sku"
                />
              ) : (
                <div className="no-Data">
                  <h1>No Data</h1>
                </div>

              )
            ) : (
              loading && (
                <div className="loader" style={{ marginTop: "20px" }}>
                  <Spin size="medium" />
                </div>
              )
            )
          }
        </div>
      </div>
      <Modal
        title="Confirm Action"
        visible={isModalVisible}
        onOk={handleConfirm}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
      >
        Are you sure you want to {amazonProductInformation?.payload?.data[0]?.status === 'Inactive' ? 'activate' : 'de-activate'} these products?
      </Modal>

      <Modal
        title="Product Details"
        visible={isViewModalOpen}
        onCancel={() => setIsViewModalOpen(false)}
        footer={null}
        width={1200}
      >
        {viewLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Row gutter={24}>
            {/* LEFT SIDE IMAGE */}
            <Col span={8}>
              <Image
                width="100%"
                // height="400px"
                style={{
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
                src={
                  tableData?.[0]?.image_url ||
                  "https://d2ckw86bt3u49z.cloudfront.net/products/Not-Found.jpg"
                }
                alt="Product"
              />
            </Col>

            {/* RIGHT SIDE DETAILS TABLE */}
            <Col span={16}>
              <div className="table_content international_order table_content_amazon">
                <Table
                  size="small"
                  className="fix-scroll-amazon-table  table-header-sticky  border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style  border"
                  // className=" border-line-th  bottom-align-th  table-td-border-right  th-general-style td-general-style border prod-table omsTable"
                  pagination={false}
                  bordered
                  columns={viewColumns}
                  dataSource={tableData}
                  // scroll={{ x: 'calc(100%)', y: 'calc(100vh - 357px)' }}
                  scroll={{ x: 'max-content' }}
                />
              </div>
            </Col>
          </Row>
        )}
      </Modal>

    </div>
  );
};

export default AmazonProductInformation;
